import React from "react"
import Isvg from "react-inlinesvg"
import { CarouselTrashIcon_s } from "components/table/carousel/carousel-styles"
import carouselService from "data/carousel"
import { NoneStateIcon } from "images/icons/tools/"

type NoneStateProps = {
  noneState?: any
  persist?: Function
}

const NoneStateTrashIcon = (props: NoneStateProps) => {
  // setting a timeout here because there is a race condition between icon click and editable field blur
  // where the click fires and replaces the data with None but then the blur fires after and reestablishes the cleared out data
  // the option i tried first was to use dom order of operations to my advantage, and call on the onMouseDown event here
  // where we could then block default, which would block the blur event on the last focused field
  // but in attempting this, it caused many other bugs because we are using Click everywhere else, so would
  // require a refactoring and retesting of all of the automation just to solve this one issue
  // at this point i believe a timeout to be the lesser of two evils
  return (
    <CarouselTrashIcon_s onClick={() => setTimeout(() => props.persist ? props.persist() : carouselService.noneState(props.noneState), 200)} title="Clear Inputs">
      <Isvg src={NoneStateIcon} />
    </CarouselTrashIcon_s>
  )
}

export default NoneStateTrashIcon